import React, { FC } from 'react'
import './index.scss'

// interface
interface IProps extends React.HTMLAttributes<HTMLDivElement>{
}

const VersionBar: FC<IProps> = () => {
  return (
    <div className='handtop-version-bar'>
      <span>V{window.buildinfo.buildDate.substr(2, 14).replace(/[-|:]/g, '').replace(' ', '-')}</span>
    </div>
  )
}

export default VersionBar
